import ServiceCategory from ".";

export const serviceCategoryRoutes = () => [
  {
    path: "/admin/services-categories",
    title: "Service Management",
    layout: "admin",
    routeType: "admin",
    component: ServiceCategory,
  },
];
